var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayrollReleaseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 15.8327H5C4.33696 15.8327 3.70107 15.5693 3.23223 15.1005C2.76339 14.6316 2.5 13.9957 2.5 13.3327V6.66602C2.5 6.00297 2.76339 5.36709 3.23223 4.89825C3.70107 4.42941 4.33696 4.16602 5 4.16602H15C15.663 4.16602 16.2989 4.42941 16.7678 4.89825C17.2366 5.36709 17.5 6.00297 17.5 6.66602V10.416M2.5 8.33268H17.5M13.3333 15.8327H18.3333M18.3333 15.8327L15.8333 13.3327M18.3333 15.8327L15.8333 18.3327M5.8375 12.4993H5.84167M9.16667 12.4993H10.8333",
    stroke: "black",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayrollReleaseIcon);
export default __webpack_public_path__ + "static/media/PayrollReleaseIcon.0aea4ebe3e44d0034fc4180732d61e15.svg";
export { ForwardRef as ReactComponent };